import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyEmail } from '../services/api';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Lien de confirmation invalide.');
      return;
    }
    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Lien invalide ou expiré.');
      });
  }, [token]);

  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif', padding: '20px' }}>
      {/* Logo */}
      <div style={{ marginBottom: '40px', textAlign: 'center' }}>
        <p style={{ fontSize: '28px', fontWeight: '900', letterSpacing: '4px', textTransform: 'uppercase', color: '#000', margin: 0 }}>
          ROYAL <span style={{ color: '#EAB308' }}>CARS</span>
        </p>
      </div>

      <div style={{ background: '#fff', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: '48px 40px', maxWidth: '440px', width: '100%', textAlign: 'center' }}>

        {status === 'loading' && (
          <>
            <div style={{ width: '60px', height: '60px', border: '4px solid #000', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 24px' }} />
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            <p style={{ color: '#555', fontSize: '16px' }}>Vérification en cours...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ width: '72px', height: '72px', background: '#dcfce7', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
              <svg width="36" height="36" fill="none" viewBox="0 0 24 24" stroke="#16a34a" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#111', marginBottom: '12px' }}>Email confirmé !</h2>
            <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.6', marginBottom: '32px' }}>
              Votre adresse email a été vérifiée avec succès. Vous pouvez maintenant vous connecter.
            </p>
            <button
              onClick={() => navigate('/connexion')}
              style={{ background: '#000', color: '#fff', border: 'none', padding: '14px 40px', borderRadius: '8px', fontWeight: '700', fontSize: '15px', cursor: 'pointer', width: '100%' }}
            >
              Se connecter
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ width: '72px', height: '72px', background: '#fee2e2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
              <svg width="36" height="36" fill="none" viewBox="0 0 24 24" stroke="#dc2626" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#111', marginBottom: '12px' }}>Lien invalide</h2>
            <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.6', marginBottom: '32px' }}>{message}</p>
            <button
              onClick={() => navigate('/inscription')}
              style={{ background: '#000', color: '#fff', border: 'none', padding: '14px 40px', borderRadius: '8px', fontWeight: '700', fontSize: '15px', cursor: 'pointer', width: '100%' }}
            >
              Créer un compte
            </button>
          </>
        )}
      </div>

      <p style={{ marginTop: '32px', color: '#999', fontSize: '13px' }}>
        © 2025 Royal Cars · <a href="https://www.royal-car.fr" style={{ color: '#EAB308', textDecoration: 'none' }}>www.royal-car.fr</a>
      </p>
    </div>
  );
}
